import {postRequest} from "@pg-mono/request";
import {apiUserLink} from "@pg-mono/rp-api-routes";

import {clientRpRequestMeta} from "../../../client/client_rp_request_meta";
import {kmUrl, oneTapClient} from "../../app/read_rp_environment_variables";

export enum SocialUserAccountType {
    FACEBOOK = 1,
    GOOGLE = 2,
    GOOGLE_ONE_TAP = 3
}

interface IThirdPartyLogin {
    credential: string;
    login_method: number;
    type: SocialUserAccountType;
    redirect_to: string;
    login_token: {
        token: string;
    };
    client_id: string;
}

type ThirdPartyLoginRequest = Omit<IThirdPartyLogin, "login_token">;

export const oneTapLogin = (params: {credential: string; onSuccess: (isNewUser: boolean) => void; onError: (error: unknown) => void}) => {
    postRequest(clientRpRequestMeta, apiUserLink.thirdPartyLogin, {
        credential: params.credential,
        redirect_to: getRedirectUrl(),
        ...GoogleOneTapBasePayload,
        client_id: oneTapClient
    })
        .then((res) => {
            params.onSuccess(!!res?.is_new);
            if (kmUrl) {
                window.open(kmUrl, "_blank");
            }
            window.location.href = buildRedirectChainStartingUrl(res.login_token.token);
        })
        .catch((error) => {
            params.onError(error);
        });
};

const getRedirectUrl = () => {
    return window.location.href;
};

const GoogleOneTapBasePayload: Omit<ThirdPartyLoginRequest, "credential" | "redirect_to" | "login_token" | "client_id"> = {
    login_method: 2,
    type: SocialUserAccountType.GOOGLE_ONE_TAP
};

const buildRedirectChainStartingUrl = (token: string) => {
    return kmUrl + "/login-token/" + token;
};
import {postRequest} from "@pg-mono/request";
import {apiUserLink} from "@pg-mono/rp-api-routes";

import {clientRpRequestMeta} from "../../../client/client_rp_request_meta";
import {kmUrl, oneTapClient} from "../../app/read_rp_environment_variables";

export enum SocialUserAccountType {
    FACEBOOK = 1,
    GOOGLE = 2,
    GOOGLE_ONE_TAP = 3
}

interface IThirdPartyLogin {
    credential: string;
    login_method: number;
    type: SocialUserAccountType;
    redirect_to: string;
    login_token: {
        token: string;
    };
    client_id: string;
}

type ThirdPartyLoginRequest = Omit<IThirdPartyLogin, "login_token">;

export const oneTapLogin = (params: {credential: string; onSuccess: (isNewUser: boolean) => void; onError: (error: unknown) => void}) => {
    postRequest(clientRpRequestMeta, apiUserLink.thirdPartyLogin, {
        credential: params.credential,
        redirect_to: getRedirectUrl(),
        ...GoogleOneTapBasePayload,
        client_id: oneTapClient
    })
        .then((res) => {
            params.onSuccess(!!res?.is_new);
            if (kmUrl) {
                window.open(kmUrl, "_blank");
            }
            window.location.href = buildRedirectChainStartingUrl(res.login_token.token);
        })
        .catch((error) => {
            params.onError(error);
        });
};

const getRedirectUrl = () => {
    return window.location.href;
};

const GoogleOneTapBasePayload: Omit<ThirdPartyLoginRequest, "credential" | "redirect_to" | "login_token" | "client_id"> = {
    login_method: 2,
    type: SocialUserAccountType.GOOGLE_ONE_TAP
};

const buildRedirectChainStartingUrl = (token: string) => {
    return kmUrl + "/login-token/" + token;
};
